import React, { Fragment } from 'react';
import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { size } from '../util';

const useStyles = makeStyles({
  stat: {
    '& svg': {
      width: '12px',
      marginLeft: '5px',
    },
    fontSize: '12px',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    color: grey[400],
    marginRight: '30px',
  }
})

export default function Speed(props: { uploadSpeed?: number, downloadSpeed?: number }) {
  const { uploadSpeed, downloadSpeed } = props;
  const classes = useStyles();
  return (
    <span className={classes.stat}>
      {!!uploadSpeed &&
      <Fragment>
        <ArrowUpward /> {size(uploadSpeed)}
      </Fragment>
      }
      {!!downloadSpeed &&
      <Fragment>
        <ArrowDownward /> {size(downloadSpeed)}
      </Fragment>
      }
    </span>
  );
}